<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-cc-vscroll-table #ccTable [transPartKey]="transPartKey"
                      [tableConfig]="tableConfig"
                      [headerButtonConfig]="headerButtonConfig"
                      [contextMenuConfig]="tableContextMenuConfig"
                      [records]="records"
                      [recordIds]="recordIds"
                      [(selectedIds)]="selectedIds"
                      (selectedIdsChange)="refreshSelectionInfos(); selectedIdsChange.emit($event);"
                      [totalRecords]="totalRecords" [loading]="tableLoadingCount>0"
                      [currentRequest]="tableCurrentRequest"
                      (loadRecordsEvent)="loadRecords($event)"
                      [fieldName]="'id'" [fieldId]="'id'" [scrollHeightNumber]="scrollHeight"
                      [defaultSortField]="tableConfigService.defaultSortField" [defaultSortOrder]="tableConfigService.defaultSortOrder"
                      (onRowDblClick)="rowDblClick()"
                      (onCtrlShift)="rowDblClick()"
                      (filterChangedEvent)="filterSortChanged()" (sortChangedEvent)="filterSortChanged()"
                      (onColOrderChange)="colOrderChanged($event)"
                      [headerTitle]="'page.' + this.transPartKey + '.header_count_clearing'">

  <span caption-left-left pButton class="p-button-text p-button-sm header-button"
          [icon]="'fa fa-bars-staggered'"
          (click)="activeChanged()" pTooltip="{{'page.' + this.transPartKey + '.table.'+
          'disable_trademode' | translate}}"></span>
  <button caption-right pButton class="p-button-text p-button-sm header-button" [icon]="'fa fa-table-columns'"
          (click)="selectTableColumns()" pTooltip="{{'common.table.select_visible_columns' | translate}}"
          tooltipPosition="left"></button>
  <button *ngIf="maximizable" caption-right pButton class="p-button-text p-button-sm header-button"
          [icon]="'fa fa-'+(maximized?'compress':'expand')"
          (click)="maximize()" pTooltip="{{'common.'+(maximized?'minimize':'maximize') | translate}}"
          tooltipPosition="left"></button>
  <span
    footer-left>{{('common.lastUpdated'|translate) + ': ' + (lastUpdated ? (lastUpdated|date:'HH:mm:ss') : '')}}</span>
  <app-clearing-selection-summary footer-right [isDark]="true"
                                  [summaryBuyValue]="summaryBuyValue"
                                  [summarySellValue]="summarySellValue"></app-clearing-selection-summary>
  <p-progressSpinner footer-right class="cc-spinner-sm" *ngIf="isSelectionInfoLoading" strokeWidth="5"
                     fill="var(--surface-ground)" animationDuration="0.8s"></p-progressSpinner>

</app-cc-vscroll-table>
<app-clearing-move-order-form #moveOrderForm (onSavedForm)="onMoveOrderSubmit($event)"></app-clearing-move-order-form>

<app-clearing-clearing-detail #clearingDetailDialog></app-clearing-clearing-detail>

<app-clearing-select-table-columns-form #selectTableColumnsDialog
                                        (onSavedForm)="onSelectTableColumns($event)"></app-clearing-select-table-columns-form>
